import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiKentimaDoubleYpsiliRight';
const args = {};

export class PetastiKentimaDoubleYpsiliRight extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
